import imageCompression from "browser-image-compression";

export const errorHandler = (error) => {
  console.log(error);
  let errorMessage = "";
  if (error.response.status === 401) {
    errorMessage = error.response.data.error || error.response.data.message;
  } else if (error.response.status === 400) {
    errorMessage = error.response.data.message || error.response.data.error;
  } else if (error.response.status === 404) {
    errorMessage = "ERR_BAD_REQUEST: Request not handled";
  } else if (error.response.status === 422) {
    errorMessage = error.response.data.message;
  } else if (error.response.status === 501) {
    errorMessage = error.response.data.error;
  } else if (error.response.status === 500) {
    errorMessage = error.response.data.error;
  } else if (error.code === "ECONNABORTED") {
    errorMessage = "Connection Aboarted";
  } else {
    errorMessage = error.message;
  }
  return errorMessage;
};

export const autocompleteStyleOverrides = {
  "& .MuiInputBase-root": {
    height: "42px",
  },
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    lineHeight: "1.7rem",
  },
};

function generateRandomId() {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}

export const getTableParams = (params) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

function blobToFile(blob) {
  const fileName = blob.name;
  const fileType = blob.type;
  const lastModified = blob.lastModified;

  // Assuming you have the compressed blob, you can create a new File object like this:
  const file = new File([blob], fileName, {
    type: fileType,
    lastModified: lastModified,
  });

  return file;
}

export async function compressFile(file, fieldName, ref) {
  const { setFieldValue } = ref.current;
  const imageFile = file;

  console.log("originalFile instanceof Blob", imageFile instanceof Blob); // true
  console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    const compressedFile = await imageCompression(imageFile, options);
    console.log(
      "compressedFile instanceof Blob",
      compressedFile instanceof Blob
    ); // true
    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

    setFieldValue(fieldName, blobToFile(compressedFile));

    // await uploadToServer(compressedFile); // write your own logic
  } catch (error) {
    setFieldValue(fieldName, imageFile);
    console.log({ error });
  }
}

// Function to generate image URL based on environment and Plant_Img value
// console.log("ENV VARIABLES", import.meta);
export const getImageUrl = (
  imagePath,
  environment = import.meta.env.VITE_APP_ENVIRONMENT
) => {
  const baseUrl = import.meta.env.VITE_APP_API_URL;
  if (!imagePath) return null;

  // Split the comma-separated string into an array
  const imagePaths = imagePath.split(',');
  const fullUrls = imagePaths
    .map((path) => `${baseUrl}${path.trim()}`)
    .join(',');

  return fullUrls;
};

export function extractFileName(url) {
  if (url === null) return;
  // Find the index of the last occurrence of '/'
  const lastSlashIndex = url.lastIndexOf("/");

  // Extract the file name using substring
  const fileNameWithExtension = url.substring(lastSlashIndex + 1);

  // Remove the random number and timestamp and get only the name
  const fileNameWithoutExtension = fileNameWithExtension
    .replace(/^[\d_]+/, "")
    .split(".")
    .slice(0, -1)
    .join(".");

  // Get the file extension
  const fileExtension = fileNameWithExtension.split(".").pop();

  // Concatenate the name and extension
  const fullFileName = `${fileNameWithoutExtension}.${fileExtension}`;

  return fullFileName;
}

export default generateRandomId;
